import { useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function CrispChat() {
  useEffect(() => {
    const loadCrisp = async () => {
      try {
        const res = await axios.get(`${API}/api/contact/crisp-id`);
        const id = res.data?.crisp_website_id;
        if (!id) return;
        if (window.$crisp) return; // already loaded
        window.$crisp = [];
        window.CRISP_WEBSITE_ID = id;
        const s = document.createElement('script');
        s.src = 'https://client.crisp.chat/l.js';
        s.async = true;
        document.head.appendChild(s);
      } catch {
        // Crisp not configured, skip silently
      }
    };
    loadCrisp();
  }, []);

  return null;
}
